import { Empty, Space, Tag, Table } from 'antd';
import { useEffect, useState } from 'react';
import { QAItem, TagComponent } from './productQA-item';
import { request } from '@/utils/request';
import dayjs from 'dayjs';
import { useAccess, Access } from 'umi';

export type VersionChangeProps = {
  from: number;
  to: number;
}

interface IndexProps {
  id: number;
  permit: boolean;
  handleVersion: (payload: VersionChangeProps) => void;
}

const Index: React.FC<IndexProps> = ({ id, handleVersion, permit }) => {
  const [data, setData] = useState<QAItem[]>([]);
  const access = useAccess();
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      const { resp } = await request(`/local/knowledge/productQA/${id}`);
      if (resp?.code !== 0) return;
      const data: QAItem[] = resp.data.list;
      setData(data.filter(d => d.id !== id));
      setLoading(false);
    }
    if (id) {
      fetchData();
    } else {
      setData([]);
    }
  }, [id]);

  const handleChangeVersion = async (payload: VersionChangeProps) => {
    await handleVersion(payload);
  }

  return (
    !id || loading ? <></> : data.length > 0 ?
      <Table
        pagination={false}
        columns={[
          {
            title: '版本',
            dataIndex: 'version',
            key: 'version',
            render: _ => <Tag>{"v" + _}</Tag>
          },
          {
            title: '问题',
            dataIndex: 'question',
            key: 'question',
          },
          {
            title: '答案',
            dataIndex: 'answer',
            key: 'answer',
          },
          {
            title: "操作成员",
            width: '100px',
            dataIndex: "teamWorker",
            key: "teamWorker",
            render: (c, _: QAItem) => {
              if (!_.verifiedName && !_.creator && !_.teamWorker) return <>-</>
              return <Space direction="vertical">
                <TagComponent value={_.verifiedName ?? ""} color="gold" />
                <TagComponent value={_?.creator?.name} color="blue" />
                <TagComponent value={_?.teamWorker?.name} color="green" />
              </Space>
            },
          },
          {
            title: '创建时间',
            dataIndex: 'createdAt',
            render: _ => <Tag color="cyan">{dayjs(_).format("YYYY/MM/DD HH:mm:ss")}</Tag>
          },
          ...[access.productQAEdit && permit ? {
            title: "操作",
            render: (record: QAItem) => <a onClick={() => handleChangeVersion({ from: id, to: record.id })}>变更为此版本</a>
          } : {}]
        ]}
        dataSource={data}
        rowKey={"id"}
      />
      : <Empty />
  );
}

export default Index;

